import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    leftInfoList;
    selectTrackId;
    visibleConfirm = false;
    isBorder = true;
    colors = colors;
    activeBorderColor = colors.borderItemHover;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    get isChinese() {
        return localStorage.getItem('language') === 'zh';
    }
    del(id) {
        this.$emit('delete', id);
        this.visibleConfirm = false;
    }
    hide(id, bool) {
        this.$emit('hide', id, bool);
    }
    isSelectTrack(id) {
        return Number(id) === this.selectTrackId;
    }
    // 选中
    selectTra(item, index) {
        if (item.isHide || !item.hasMap)
            return;
        this.$emit('selectTra', item, index);
    }
};
__decorate([
    Prop({ default: [], type: Array })
], default_1.prototype, "leftInfoList", void 0);
__decorate([
    Prop()
], default_1.prototype, "selectTrackId", void 0);
default_1 = __decorate([
    Component({
        name: 'RouteLeft',
        components: { BlurPicture },
        i18n: {
            messages: {
                'en-us': {
                    hide: 'Hide',
                    delete: 'Delete',
                    noLocation: 'The device is not marked on the map, please go to the Map Management to add',
                    deleteList: 'The popup will be closed after deleting the last list',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                },
                zh: {
                    hide: '隐藏',
                    delete: '删除',
                    noLocation: '设备未在地图上标记，请到 地图管理 模块添加。',
                    deleteList: '删除最后一个列表会关闭弹框，确认吗?',
                    cancel: '取消',
                    confirm: '确认',
                },
            },
        },
    })
], default_1);
export default default_1;
